/**
 * Styled Components - Created by david on 10/04/18.
 */
import styled from 'styled-components'
import Search from 'antd/lib/auto-complete'
import Button from 'antd/lib/button'
import InputComponent from 'antd/lib/input'
import { BLUE, GRAY_DARK, GRAY_LIGHT, GREEN_BRIGHT, RED, WHITE } from '../../../theme/colors'
import Icon from 'antd/lib/icon'

const { TextArea } = InputComponent

export const Container = styled.div`
   background-color: #222;
 `

export const Text = styled.div`
   color: #fff;
 `

export const Title = styled.div`
   color: #5f6062;
   font-size: 18px;
   font-weight: 600;
   line-height: 25px;
   margin-top: 4px;
   margin-bottom: -4px;
   margin-left: 10px;
 `

export const Subtitle = styled.div`
  font-size: 14px;
  font-weight: normal;
`

export const List = styled.div`
   padding-top: 22px;
   min-height: 128px;
   overflow: auto;
   white-space: nowrap;
   display: flex;
   flex-direction: row;
   flex-wrap: wrap;
   justify-content: center;
   width: 100%;
   align-items: flex-start;
 
   @media (min-width: 320px) and (max-width: 480px) {
     height: auto;
   }
 `

export const ErrorContainer = styled.div`
   display: flex;
   flex: 1;
   height: 60vh;
   justify-content: center;
   align-items: center;
   flex-direction: column;
 `

export const ErrorTitle = styled.div`
   color: #5f6062;
   font-size: 16px;
   font-weight: 600;
   line-height: 22px;
 `

export const Message = styled.div`
   margin-top: 16px;
   font-size: 16px;
   line-height: 23px;
   text-align: center;
 `

export const modalStyle = { paddingBottom: '96px' }

export const bodyStyle = { padding: '12px' }

export const PaginationRow = styled.div`
   text-align: right;
   padding-right: 2%;
   margin-top: 10px;
 
   @media (min-width: 320px) and (max-width: 480px) {
     padding: 0;
     text-align: center;
   }
 `

export const NotFound = styled.div`
   font-size: 18px;
 `

export const StyledSearch = styled(Search)`
   width: 100%;
   .ant-select-selection__rendered {
     line-height: 50px !important;
   }
 `

export const Input = styled(InputComponent)`
   border-radius: 0;
   margin-top: 6px;
 `

export const SearchButton = styled(Button)`
   height: 100%;
   border: none;
   width: 35px;
 `

export const TopSection = styled.div`
   display: flex;
   align-items: center;
   justify-content: space-between;
   @media (max-width: 698px) {
    flex-flow: column;
    align-items: flex-end;
   }
 `

export const SelectAllDiv = styled.div`
   display: flex;
   justify-content: center;
   align-items: center;
   margin-right: 6px;
   margin-left: 18px;
   height: 50px;
   min-width: 50px;
 `

export const SelectAllLabel = styled.div`
   white-space: nowrap;
   padding: 8px 12px;
   border: 1px solid ${RED};
   border-radius: 3px;
   color: ${RED};
   font-size: 12px;
   transition: all .25s;
   &:hover {
     cursor: pointer;
     background: ${RED};
     color: ${WHITE};
   }
 `

export const TopLabels = styled.div`
  display: flex;
  align-items: center;
`

export const AdviseLabel = styled.div`
  margin-right: 30px;
  font-size: 12px;
`

export const TotalAmountsIcon = styled(Icon)`
  margin-right: 10px;
  color: ${RED};
`

export const TotalAmounts = styled.div`
  margin-right: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 10px;
`

export const RightSection = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-end;
  margin-right: 12px;
`

export const ActionButtons = styled.div`
  display: inline-flex;
  margin-right: 12px;
`

export const AddButton = styled.div`
  color: #fff;
  background-color: #e61737;
  border-color: #e61737;
  text-shadow: 0 -1px 0 rgb(0 0 0 / 12%);
  box-shadow: 0 2px 0 rgb(0 0 0 / 5%);
  width: fit-content;
  padding: 8px 14px;
  border-radius: 5px;
  margin-right: 8px;
  height: fit-content;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const CancelButton = styled.div`
  box-shadow: 0 2px 0 rgb(0 0 0 / 2%);
  color: rgba(0, 0, 0, 0.65);
  background-color: #fff;
  border: 1px solid #d9d9d9;
  width: fit-content;
  padding: 7px 12px;
  border-radius: 5px;
  height: fit-content;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const TotalDiv = styled.div`
  display: flex;
  align-items: flex-end;
  font-size: 16px;
  margin-bottom: 4px;
`

export const TotalValue = styled.div`
  font-size: 20px;
  margin-left: 8px;
  color: ${GREEN_BRIGHT};
  font-weight: bold;
  font-family: Avenir;
  margin-bottom: -3px;
`

export const ItemsAmount = styled.div``

export const SaveButtonStyle = {
  backgroundColor: `${BLUE}`,
  borderColor: `${BLUE}`
}

export const SaveButtonNotesStyle = {
  backgroundColor: 'rgb(114 104 193)',
  borderColor: 'rgb(114 104 193)',
  color: WHITE,
  textShadow: 'none',
  boxShadow: '1px 1px 3px 0px #cccccc'
}

export const CancelButtonNotesStyle = {
  background: WHITE,
  color: GRAY_DARK,
  borderColor: GRAY_LIGHT,
  textShadow: 'none'
}

export const ThumbnailContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-flow: column;
  align-items: center;
`

export const NoteDiv = styled.div`
  display: flex;
  flex-flow: column;
  background: whitesmoke;
  padding: 12px 16px;
  border-radius: 5px;
  margin: 0 12px;
  font-size: 13px;
`

export const NoteTitle = styled.div`
  font-weight: bold;
  margin-bottom: 10px;
  span {
    color: #d26262;
  }
`

export const NoteDescription = styled.div`
  margin-bottom: 12px;
`

export const StyledInput = styled(TextArea)`
  &:hover {
    border-color: #acbdea;
  }
  &:focus {
    border-color: #879fe0;
    box-shadow: none;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/CheckoutPrintCheckModal/DesignsPrintModal/styledComponents.tsx